<section class="mission">
<div class="section-name">
    <h6>
        Mission
    </h6>
    <div class="line"></div>
</div>
<div class="mission-wrapper">
<div class="row justify-content-center">
    <div class="col-12 col-md-12 col-lg-4 cw-card-item">
      
        <h3 class="cw-card-title mission-statement">Mission Statement</h3>
        <div class="cw-card-text">
            <p>To give our customers the most compelling experience of their lives.</p>
        </div>
    </div>
    <div class="col-12 col-md-12 col-lg-4 cw-card-item">
        
        <h3 class="cw-card-title vision-statement">Vision Statement</h3>
        <div class="cw-card-text">
            <p>To make work & education as entertaining and inspiring as possible.
            </p>
        </div>
    </div>
    <div class="col-12 col-md-12 col-lg-4 cw-card-item">
      
        <h3 class="cw-card-title our-values">Our Values</h3>
        <div class="cw-card-text">
            <ul class="our-values-list">
                <li>
                    Respect all living things.
                </li>
                <li>
                    Abide by the Golden Rule.
                </li>
                <li>
                    Be Honorable.
                </li>
                <li>
                    Do your best at whatever you do, the first time and every time.
                </li>
            </ul>
        </div>
        
    </div>
</div>
</div>
</section>
